import _sortBy from 'lodash/sortBy';
import React from 'react';
import {
  Configure,
  InstantSearch,
  Pagination,
  RefinementList,
  SearchBox
} from 'react-instantsearch-dom';

import { indexName, searchClient } from '.';
import PageHits from './PageHits';

const DEBOUNCE_TIME = 200;

const queryFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const q = urlParams.get('q');

  return q || '';
};

const createURL = (searchState) => {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set('q', searchState.query);

  if (searchState.query.length) {
    return window.location.pathname + '?' + urlParams.toString();
  }

  return window.location.pathname;
};

const searchStateToURL = (searchState) => (searchState ? createURL(searchState) : '');

/**
 * Search component with auto updating url based on
 * https://www.algolia.com/doc/guides/building-search-ui/going-further/routing-urls/react
 */
class Search extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      searchState: { query: '' },
      debouncedSetState: null
    };

    this.onSearchStateChange = this.onSearchStateChange.bind(this);
  }

  componentDidMount() {
    this.setState({ searchState: { query: queryFromUrl() } });
  }

  onSearchStateChange(newSearchState) {
    clearTimeout(this.state.debouncedSetState);

    this.setState({
      debouncedSetState: setTimeout(() => {
        const newUrl = searchStateToURL(newSearchState);

        window.history.pushState({}, '', newUrl);
      }, DEBOUNCE_TIME)
    });

    this.setState({ searchState: newSearchState });
  }

  render() {
    return (
      <InstantSearch
        indexName={indexName}
        searchClient={searchClient}
        searchState={this.state.searchState}
        onSearchStateChange={this.onSearchStateChange}
        createURL={searchStateToURL}
      >
        {/* https://www.algolia.com/doc/api-reference/search-api-parameters */}
        <Configure
          hitsPerPage={20}
          distinct={1}
          attributesToHighlight={['title', 'teaser', 'content', 'context_info', 'summary']}
          // https://www.algolia.com/doc/api-reference/api-parameters/attributesToSnippet/
          attributesToSnippet={[
            'title:100',
            'teaser:100',
            'content:100',
            'context_info:100',
            'summary:100'
          ]}
          highlightPreTag="<b>"
          highlightPostTag="</b>"
          queryLanguages={['de']}
          ignorePlurals
          removeStopWords
        />
        {/* https://www.algolia.com/doc/api-reference/widgets/refinement-list/react */}
        <SearchBox
          autoFocus
          submit={<img src="/assets/icon-24px-search-outline.png" />}
          reset={<img src="/assets/icon-24px-close-outline.png" />}
          translations={{
            submitTitle: 'Suche abschicken',
            resetTitle: 'Sucheingabe löschen',
            placeholder: 'Suche'
          }}
        />
        {/* https://www.algolia.com/doc/api-reference/widgets/hits/react */}
        {!!this.state.searchState.query.length && (
          <RefinementList
            attribute="article_type"
            sortBy={['name:asc']}
            transformItems={(items) => {
              return _sortBy(
                items.map((item) => {
                  switch (item.label) {
                    case 'Default Index':
                      return { ...item, label: 'Artikel' };
                    case 'Report Index':
                      return { ...item, label: 'News' };
                    case 'Event Index':
                      return { ...item, label: 'Veranstaltungen' };
                    case 'Pressrelease Index':
                      return { ...item, label: 'Pressemitteilungen' };
                    case 'Newsletter Index':
                      return { ...item, label: 'Newsletter' };
                    case 'Consultant Index':
                      return { ...item, label: 'Berater' };
                    case 'Branch Index':
                      return { ...item, label: 'Niederlassungen' };
                    case 'Joboffer Index':
                      return { ...item, label: 'Stellenangebote' };
                    case 'EmailContent Index':
                      return { ...item, label: 'E-Mail-Inhalte' };
                    case 'External Index':
                      return { ...item, label: 'Externe Artikel' };
                    default:
                      return item;
                  }
                }),
                'label'
              );
            }}
          />
        )}
        <hr style={{ borderWidth: 1 }} />
        {/* https://www.algolia.com/doc/api-reference/widgets/hits/react */}
        {!!this.state.searchState.query.length && <PageHits />}
        {/* https://www.algolia.com/doc/api-reference/widgets/pagination/react */}
        {!!this.state.searchState.query.length && (
          <Pagination
            translations={{
              previous: '«',
              next: '»',
              first: '|‹',
              last: '›|',
              ariaPrevious: 'Vorherige Seite',
              ariaNext: 'Nächste Seite',
              ariaFirst: 'Erste Seite',
              ariaLast: 'Letzte Seite',
              ariaPage(currentRefinement) {
                return `Seite ${currentRefinement}`;
              }
            }}
          />
        )}
      </InstantSearch>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./components/search/Search.js